/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Rating_TitleInputs */

const en_onboarding_rating_title = /** @type {(inputs: Onboarding_Rating_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Give us a rating`)
};

const es_onboarding_rating_title = /** @type {(inputs: Onboarding_Rating_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Danos una calificación`)
};

/**
* | output |
* | --- |
* | "Give us a rating" |
*
* @param {Onboarding_Rating_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const onboarding_rating_title = /** @type {((inputs?: Onboarding_Rating_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Rating_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_onboarding_rating_title(inputs)
	return en_onboarding_rating_title(inputs)
});